<template>
	<div>
		<!-- visa kategori lista -->
		<div style="margin-bottom:10px;">

			<!--sökfält -->
			<div class="form textField" title="">
				<input type="text" placeholder="Sök bland kategorier" v-model="this.filter" style="" />
				<img src="@/assets/button_close_dark.png" @click="this.filter = ''"
					style="height:20px;width:20px;margin-right:5px;" />
			</div>

			<!-- sök resultatlist -->
			<div v-if="this.filter">
				<div style="margin-top:10px;">
					<div v-for="category in this.categoryListSearch" :key="category.categoryId" class="flexcenter link"
						@click="this.searchCategoryIdSelected(category.categoryId)"
						style="background-color: var(--grey-2);margin-bottom:5px;border-radius: 5px;padding:5px;">
						<div class="flexcenter" style="flex-direction: column;align-items:start;flex-grow:1;">
							<b>{{ category.name }}</b>
							<b style="color:grey;padding-top:3px;" class="font-smaller">{{ category.path }}</b>
						</div>
						<div>
							<Icon fileName="w3_chevron_right_light" style="height:20px;width:12px;" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- visa vald kategori -->
		<div v-if="!this.filter && this.selectedCategory">

			<!-- vald kategori stor kategoribild -->
			<div id="mainCategoryImage" class="link flexcenter" @click="this.categorySelected(null)"
				style="border:0px solid green;align-items:end;justify-content:end;">


				<div id="mainCategoryImageLabel" style="">
					{{ this.mainCategory?.name?.toUpperCase() }}</div>
				<!--div v-if="this.selectedCategory?.pathIdList?.length > 1" style="color:white;padding-top:10px;padding-left:10px;">{{ this.selectedCategory?.name }}</div -->

			</div>


			<!-- den valda kategorin header -->
			<div class="flexcenter link" style="background:var(--white);padding:5px;"
				@click="this.parentCategorySelected(this.selectedCategory)">
				<Icon fileName="w3_chevron_left_dark" style="height:15px;width:10px;padding-right:5px;" /> <b
					style="flex-grow:1;font-size: 130%;">{{
					this.selectedCategory?.name }} </b>

				<!-- klickbar badge med alla -->
				<div class="flexcenter" style="background:var(--grey-3);padding:5px;border-radius: 5px;"
					@click.stop="this.categorySelectedShowProductList(this.selectedCategory)"
					:title="'Visa alla produkterna i kategori: ' + this.selectedCategory.path">
					<b>{{ this.prouductCountLabel(this.selectedCategory) }}</b>
					<Circle fileName="w3_chevron_right_dark" color="" padding="25%" hover="" size="15px" />
				</div>

			</div>

			<!-- lista med underkategorier till vald kategori -->
			<div v-for="category in this.selectedCategory?.categoryList" :key="category.categoryId">
				<div style="background:var(--grey-2);padding:5px;margin-bottom:5px;border-radius: 5px;"
					@click.stop="this.categorySelectedShowProductList(category)" class="link flexcenter"><b> {{ category?.name
						}}</b> <b style="flex-grow:1;">&nbsp;</b>
					<div class="flexcenter">


						<!-- click visa underkategorier -->
						<div v-if="category.categoryList?.length > 0"
							style="display:flex;background:lightgray;padding-top:3px;padding-bottom:3px; width:100px;justify-content:end;"
							@click.stop="this.categorySelected(category)">
							<Circle fileName="w3_chevron_right_dark" color="" padding="25%" hover="" size="15px"
								title="Visa underkategorier" />
						</div>
						<!-- badge med antal -->
						<div v-else-if="this.prouductCountLabel(category)" class="flexcenter"
							style="background:var(--grey-4);padding:5px;border-radius: 5px;" title="Antal produkter i kategorin"><b
								class="font-smaller">{{
								this.prouductCountLabel(category) }}</b></div>
					</div>

				</div>
			</div>

		</div>




		<!-- kategorigrid med bilder -->
		<div v-if="!this.filter && !this.selectedCategory" id="startCategoryGrid" class="" style="">

			<div v-for="category in this.sortCategoryList(this.startCategoryGrid)" :key="category.categoryId"
				style="padding-bottom:10px;padding-left:0px;padding-right:0px;" class="link">


				<Card :cardtitle="category.name" @click="this.categorySelected(category)"
					:filename="cateogryIdImageList.includes(category.categoryId) ? 'category_' + category.categoryId + '.jpg' : null"
					:title="'Visa produkter i kategori: ' + category.path + ', id: ' + category.categoryId" style="" :tint="true"
					mode="dark" fontSizeTitleMax="140%" class="card" />
			</div>
		</div>
	</div>
</template>
<script>
import { STORE_GETTER } from '../../store/store';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
import { categoryMixin } from "@/mixins/categoryMixin.js";
import Card from '../Card.vue';
import categoryHelper from '../../helper/category-helper';
import listHelper from '../../helper/list-helper';
import { productSearchMixin } from "@/mixins/productSearchMixin.js";
import { routerMixin } from "@/mixins/routerMixin.js";

export default {
	name: "SideMenuCategoryList",
	components: { Card },
	mixins: [categoryMixin, productSearchMixin, routerMixin],
	props: {

	},
	data() {
		return {
			filter: null,
			selectedCategory: null
		};
	},
	computed: {

		baseModel() {
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];
			return baseModel;
		},

		prouductCountList() {

			const productCountList = this.$store.getters[STORE_GETTER.CATEGORY_PRODUCT_COUNT_LIST];


			//console.log('FP: productCountList: ', productCountList);


			return productCountList;
		},


		categoryListSearch() {

			var categoryList = this.baseCategoryModel?.categoryList?.filter(category => category !== null)


			/*if (categoryListX && this.filter && this.filter.length > 0){
				categoryListX = listHelper.filter(this.filter, categoryListX)
			}*/

			if (categoryList) {
				//categoryListX = categoryListX.filter(category => category.categoryId == 4)
				categoryList = categoryList.filter(category => {
					return listHelper.filter(category.search, this.filter);
				})
			}

			return categoryList

		},

		/*selectedCategory(){
			
			
			return this.searchProductConfig?.category;
		},*/

		searchProductConfig() {

			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		mainCategoryImagepath() {

			if (this.selectedCategory) {

				const pathId = this.parentCategoryImage(this.selectedCategory);
				//const pathId = "main_346"
				return require("@/assets/card/" + 'category_main_' + pathId + '.jpg');
			}

			return null;


		},


		mainCategoryImagepathCSS() {

			if (this.selectedCategory){
				return "url(" + this.mainCategoryImagepath + ")";
			}

			return null;
		},

		mainCategory(){
			const pathId = this.parentCategoryImage(this.selectedCategory);
			
			if (pathId && pathId > 0){
				const category = this.baseCategoryModel.categoryList?.find(category => category.categoryId == pathId)
				return category
			}

			return null;

		}


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });

		closeSideMenu(){
			
			this.$emit("sideMenuVisible", false)
		},
		categorySelected(category) {

			console.log('FP: categorySelected', category);

			/*
			if (category){
				this.searchCategorySelectedWithoutNavigation(category);
			}else{
				this.resetSearchProductConfig()
			}**/
			
		

			this.selectedCategory = category;

			/*this.searchCategorySelectedWithoutNavigation(category);
			const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];


			if (!productType) { // om ingen kategori är satt. 
				const productTypeUrlKey = this.getProductTypeUrlKeyFromCategory(category);
				this.routerShowProductListForUrlKey(productTypeUrlKey);


			} else {
				this.routerShowProductList()
			}*/


		},

		categorySelectedShowProductList(category){

			this.searchCategorySelectedWithoutNavigation(category);

			const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];

			if (!productType) { // om ingen kategori är satt. 

				const productTypeUrlKey = this.getProductTypeUrlKeyFromCategory(category);
				this.closeSideMenu()
				this.routerShowProductListForUrlKey(productTypeUrlKey);


			} else {
				this.closeSideMenu()
				this.routerShowProductList()
			}
			
		},



		parentCategorySelected(category){ // FP: Ändra till parentCategorySelected

			const parent = category.parentId;

			const parentCategory = categoryHelper.findInCategoryTree(parent, this.baseCategoryModel?.categoryTree) 

			console.log('FP: parentCategory: ', parentCategory);

			this.categorySelected(parentCategory);
			
		},

			searchCategoryIdSelected(categoryId) { // FP: letar upp rätt kategori i trädet
			console.log('FP: categoryId: ', categoryId);

			const category = categoryHelper.findInCategoryTree(categoryId, this.baseCategoryModel?.categoryTree)

				this.categorySelectedShowProductList(category);

		},



	},
	created() {

	}
};
</script>

<style scoped>


div#startCategoryGrid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(min(100%/5, max(350px, 100%/7)), 1fr));
	grid-row: auto;
	column-gap: 10px;
	row-gap: 5px;
	border: 5px solid transparent;
	align-items: stretch;

}

div#startCategoryGrid div.card {
	min-width: 200px;
	max-height: 250px;
	min-height: 300px;
	max-width: 350px;
}

div#mainCategoryImage{
		background-image: v-bind(mainCategoryImagepathCSS);
			/* */
			/*background-image: url('~@/assets/card/mc.jpg'); /* */
			object-fit: contain;
			background-size: cover;
}


@media (max-width: 1068px) {

	div#startCategoryGrid {
		display: grid;
		grid-template-columns: auto auto ;
	}

	div#startCategoryGrid div.card {
		min-height: 250px;
	}

}

@media (max-width: 768px) {

	div#startCategoryGrid {
		display: grid;
		grid-template-columns: auto auto;
	}

	div#startCategoryGrid div.card {
		min-height: 100px;
		min-width: 100px;
		aspect-ratio: 1/1;
	}

}

div#mainCategoryImage{
	height:100%;
	height: 50vh;
	width: 100%;
	background-size: cover;
	background-position: center center;
	position: relative;
		overflow: hidden;
	
}

@media (max-width: 768px) {
	div#mainCategoryImage {
		height: 50vw;
	}
}

div#mainCategoryImageLabel{
				position: absolute;
					inset: 0;
					display: flex;
					justify-content: flex-end;
					/* höger */
					align-items: flex-end;
					margin-bottom: -0.12em;
					/* botten */
					padding-right: 10px;
					font-size: clamp(40px, 8cqw, 120px);
					font-weight: 900;
					letter-spacing: -0.05em;
					line-height: 0.9;
					text-align: right;
					color: white;
	/*text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 8px rgba(0, 0, 0, 0.1);*/
}


</style>